// extracted by mini-css-extract-plugin
export default {"root":"NegotiationRequestQuoteForm_root__yb2hG","submitButton":"NegotiationRequestQuoteForm_submitButton__4t8Tf"};